// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addressDrawerContainerStyles } from "@insite/content-library/Widgets/Header/AddressDrawerContainer";
import { GridOffset } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { css } from "styled-components";

addressDrawerContainerStyles.drawerContainer = {
    gap: 0,
    css: css`
        & > ${GridOffset} > ${GridItemStyle} > div /*this div is the zone wrapper div*/ > :last-child {
            margin-bottom: 30px;
        }
    `,
};

addressDrawerContainerStyles.punchOutAddressGridItem = {
    width: 12,
};
addressDrawerContainerStyles.fulfillmentMethodGridItem = {
    width: 12,
};
addressDrawerContainerStyles.addressesGridItem = {
    width: 12,
};
addressDrawerContainerStyles.addressesGridItemAnonymousUser = {
    width: 12,
};
addressDrawerContainerStyles.pickUpAddressGridItem = {
    width: 12,
};
addressDrawerContainerStyles.pickUpAddressGridItemAnonymousUser = {
    width: 12,
};
addressDrawerContainerStyles.applyButtonGridItem = {
    width: 12,
};
